import {
  Box,
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import axios from "axios";
import Person from "@material-ui/icons/Person";
import Loader from "components/Loader";
import { misscaleneous } from "constant/network";
import { useAtom } from "jotai";
import React, { useState, useEffect } from "react";
import { projectIdStore } from "store/store";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import { API_BASE_URL } from "configs/constant";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
    minWidth: "100%",
    margin: "auto",
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  marginLeft: {
    marginLeft: 10,
  },
  disable: {
    pointerEvents: "none",
    opacity: 0.5,
  },
  modalStyle1: {
    position: "absolute",
    top: "10%",
    left: "10%",
    overflow: "scroll",
    height: "100%",
    display: "block",
  },
}));

const FieldOfficerModal = (props) => {
  const { modalOpen, handleClose, foId } = props;
  const classes = useStyles();
  const [allData, setAllData] = useState([]);

  const [projectFarms, setProjectFarms] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const [totalArea, setTotalArea] = useState([]);
  const [allVillageList, setAllVillageList] = useState([]);
  const [filterType, setFilterType] = useState(null);

  const [projectId] = useAtom(projectIdStore);

  const getFieldOfficerDataAPI = () => {
    setIsRequesting(true);
    axios
      .get(`${API_BASE_URL}${misscaleneous}?field_supervisor_id=${foId}`)
      .then((res) => {
        setAllData(res?.data);
        return res.data[0]?.field_supervisors[0]?.villages?.map((items) => {
          setAllVillageList((el) => [
            ...el,
            { value: items?.village_id, name: items?.village?.name },
          ]);
        });
      })
      .catch((err) => {})
      .finally(() => {
        setIsRequesting(false);
      });
  };

  useEffect(() => {
    if (modalOpen) {
      setAllVillageList([]);
      getFieldOfficerDataAPI();
    }
  }, [modalOpen]);

  const getFarms = () => {
    return allData[0]?.farmers?.map((item) => {
      return item?.farms?.map((items) => {
        setProjectFarms((el) => [
          ...el,
          { name: item?.name, village: item?.village?.name, items },
        ]);
      });
    });
  };

  const getVillageList = () => {
    return allData[0]?.field_supervisors?.map((item) => {
      return item?.villages?.map((items) => {
        setVillageList((el) => [...el, items?.village_id]);
      });
    });
  };

  useEffect(() => {
    if (allData && modalOpen) {
      getFarms();
      getVillageList();
    }
    if (!modalOpen) {
      setProjectFarms([]);
      setVillageList([]);
    }
  }, [allData, modalOpen]);

  const [newObject, setNewObject] = useState([]);

  const getTotalAreaCovered = () => {
    return newObject.map((item) => {
      setTotalArea((el) => [...el, Number(item?.items?.area)]);
    });
  };

  useEffect(() => {
    if (newObject) {
      setTotalArea([]);
      getTotalAreaCovered();
    }
  }, [newObject]);

  const getFarmsAcToVillage = () => {
    return villageList?.map((item, idx) => {
      return projectFarms
        ?.filter(
          (el) =>
            el?.items?.village_id === item &&
            el?.items?.project_id === projectId
        )
        ?.map((items) => {
          return setNewObject((el) => [...el, items]);
        });
    });
  };

  useEffect(() => {
    setNewObject([]);
    if (projectFarms && villageList && modalOpen) {
      getFarmsAcToVillage();
    }
  }, [projectFarms, villageList]);

  const renderProject = () => (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: "440px" }}
      style={{ overflow: "scroll" }}
    >
      <Table
        id="table-to-xls-now"
        stickyHeader
        className={classes.table}
        aria-label="caption table"
      >
        <TableHead>
          <TableRow>
            <TableCell>S.No</TableCell>
            <TableCell>Area</TableCell>
            <TableCell>Farmer Name</TableCell>
            <TableCell>Village</TableCell>
            <TableCell>Assigned</TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{ height: "30px" }}>
          {filterType ? (
            <>
              {newObject &&
                newObject
                  ?.filter((items) => {
                    return items?.items?.village_id == filterType;
                  })
                  ?.map((item, idx) => {
                    return (
                      <TableRow key={idx}>
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{item?.items?.area} acre</TableCell>
                        <TableCell>{item?.name}</TableCell>
                        <TableCell>{item?.village}</TableCell>
                        <TableCell>
                          {item?.items?.sequence !== "" ? (
                            <span style={{ color: "green" }}>Assigned</span>
                          ) : (
                            <span style={{ color: "red" }}>Not Assigned</span>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
            </>
          ) : (
            <>
              {newObject &&
                newObject?.map((item, idx) => {
                  return (
                    <TableRow key={idx}>
                      <TableCell>{idx + 1}</TableCell>
                      <TableCell>{item?.items?.area} acre</TableCell>
                      <TableCell>{item?.name}</TableCell>
                      <TableCell>{item?.village}</TableCell>
                      <TableCell>
                        {item?.items?.sequence !== "" ? (
                          <span style={{ color: "green" }}>Assigned</span>
                        ) : (
                          <span style={{ color: "red" }}>Not Assigned</span>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        className={classes.modalStyle1}
      >
        <div>
          <Loader isLoading={isRequesting} />
          <Box
            sx={{ ...style }}
            style={{ maxHeight: "500px", display: "block" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                backgroundColor: "#319069",
              }}
            >
              <Person style={{ color: "white", fontSize: "40px" }} />
              <h4
                style={{
                  fontWeight: "bold",
                  color: "white",
                  marginLeft: "10px",
                }}
              >
                {allData[0]?.field_supervisors[0]?.user_details?.name}
              </h4>
            </div>
            <div
              style={{
                display: "flex",
                // flexDirection: "column",

                marginTop: "10px",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "10px",
                }}
              >
                <span style={{ fontWeight: 500, color: "black" }}>
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    Total Jobs
                  </span>
                  : {newObject?.length}
                </span>
                <span style={{ fontWeight: 500, color: "black" }}>
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    Project
                  </span>
                  : {allData[0]?.name}
                </span>
                <span style={{ fontWeight: 500, color: "black" }}>
                  <span style={{ fontWeight: "bold", color: "black" }}>
                    Total Area Covered
                  </span>
                  : {Number(totalArea?.reduce((a, b) => a + b, 0)).toFixed(2)}{" "}
                  acres
                </span>
              </div>
              <div style={{ marginRight: "20px" }}>
                <ReactHtmlTableToExcel
                  style={{ marginLeft: "100px" }}
                  id="test-table-xls-button"
                  className="download-table-xls-button"
                  table="table-to-xls-now"
                  filename="tablexls"
                  sheet="tablexls"
                  buttonText="Export Data"
                />
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <FormControl
                variant="outlined"
                style={{
                  width: "100px",
                  marginLeft: "10px",
                  marginTop: "10px",
                }}
              >
                <InputLabel id="demo-simple-select-label">Filter</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={filterType}
                  label="Village"
                  onChange={(e) => {
                    setFilterType(e.target.value);
                  }}
                >
                  {allVillageList?.map((item) => {
                    return (
                      <MenuItem value={item?.value}>{item?.name}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <Button
                onClick={() => {
                  setFilterType(null);
                }}
              >
                Clear
              </Button>
            </div>
            <div>
              {allData[0] &&
              allData[0].field_supervisors &&
              allData[0].field_supervisors.length ? (
                renderProject()
              ) : (
                <Box
                  fontSize="h6.fontSize"
                  m={1}
                  p={{ xs: 2, sm: 2, md: 2 }}
                  style={{ textAlign: "center" }}
                >
                  No Project Found
                </Box>
              )}
            </div>
          </Box>
        </div>
      </Modal>
    </>
  );
};

export default FieldOfficerModal;
